/*
document.addEventListener('DOMContentLoaded', () => {
	let requiredFields = document.querySelectorAll('.required-field');

	requiredFields.forEach(element => {
		let 
		elPrevious = element.previousElementSibling;
		
		element.classList.add('js-required-field');
		elPrevious.appendChild(element);
	});
});

*/